import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
    ViewChild,
    ElementRef,
    AfterViewChecked,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { FormViewModel } from "./form-view.model";
import { Subject } from "rxjs";
import { BuilderService } from "../builder/builder.service";
import { fixInputSpacing } from "../formly/helpers";

@Component({
    selector: "form-view",
    templateUrl: "./form-view.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FormViewComponent implements OnInit, OnDestroy, AfterViewChecked {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    formViewModel: FormViewModel | undefined;

    @Input()
    set formModel(model: FormViewModel) {
        this.formViewModel = model;
        const fieldClassName = "form-view-input-field";
        this.fields = model.fields.map((field) => ({
            ...field,
            className: field.className ? `${field.className} ${fieldClassName}` : fieldClassName,
        }));
    }

    @Output()
    onSaving: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    onValidChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    onFormSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    onSavePromise: any;

    @Input()
    standalone: boolean;

    @Input()
    definition: string;

    @Input()
    value: any = {};

    form = new FormGroup({});

    model: any = {};

    options: FormlyFormOptions = {};

    fields: FormlyFieldConfig[] = [];

    formModelChanged = true;

    @ViewChild("formlyFormContainer") formlyFormContainerRef: ElementRef<HTMLDivElement>;

    constructor(private _builderService: BuilderService) {}

    ngOnInit(): void {
        const formDefinition = this._builderService.fromJson(this.definition);
        if (formDefinition.title) {
            const model = new FormViewModel();
            model.fields = this._builderService.toFormlyFields(formDefinition);
            model.title = formDefinition.title;
            model.description = formDefinition.description;
            this.formModel = model;
            this.formModelChanged = true;
        }
    }

    ngAfterViewChecked() {
        if (!this.formModelChanged) return;
        this.formModelChanged = false;

        this.fixSpacing();
    }

    fixSpacing() {
        if (!!this.formlyFormContainerRef?.nativeElement) {
            fixInputSpacing(this.formlyFormContainerRef.nativeElement);
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    close() {
        this.onCancel.emit(true);
    }
}
